import { svgIcon } from "@bitwarden/components";

export const ReportUnsecuredWebsites = svgIcon`
  <svg width="113" height="76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.71 12.983h110.362v55.11a6 6 0 0 1-6 6H7.711a6 6 0 0 1-6-6v-55.11Z" fill="currentColor" />
    <rect x="1" y="1.073" width="110.5" height="73.454" rx="9" stroke="#fff" stroke-width="2" />
    <path d="M89.48 8.048V7.47M96.363 8.048V7.47M103.246 8.048V7.47" stroke="#fff" stroke-width="4" stroke-linecap="round" />
    <path d="M0 12.983h111.217" stroke="#fff" stroke-width="2" />
    <path d="m93.236 44.384-18.42-11.026 2.93 21.266 5.582-5.237 4.27 6.46 2.98-1.971-4.26-6.446 6.918-3.046Z" fill="#009C9B" stroke="#fff" stroke-width="2" stroke-linejoin="round" />
    <rect width="96.673" height="6.886" rx="3.443" transform="matrix(-1 0 0 1 104.373 18.721)" stroke="#fff" />
  </svg>
`;
